export default "__VITE_ASSET__UHlK4e7z__"